module.exports = __webpack_public_path__ + "img/home-01.3415816e.png";